import { StyleSheet } from 'react-native';

import { COLOR, lightGrey } from 'utils/colors';
import { isPhone, widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    desktopContent: {
        width: widthPercentageToDP(480),
    },
    phoneContent: {
        flex: 1,
        paddingHorizontal: 16,
        justifyContent: 'center',
    },
    text: {
        textAlign: 'center',
    },
    description: {
        lineHeight: 24,
        marginTop: 16,
    },
    buttonsContainer: isPhone
        ? {
              position: 'absolute',
              left: 16,
              right: 16,
              bottom: 24,
              flexDirection: 'column-reverse',
          }
        : {
              flexDirection: 'row',
              justifyContent: 'center',
              marginTop: 40,
          },
    button: isPhone
        ? {
              width: '100%',
              marginTop: 12,
          }
        : {
              minWidth: 120,
              marginTop: 0,
          },
    buttonIndent: {
        marginLeft: isPhone ? 0 : 12,
    },
    buttonBorder: {
        borderWidth: 1,
        borderColor: lightGrey(0.5),
    },
    actionButtonText: {
        color: COLOR.BLACK,
    },
});

export default styles;
